import request from '@/axios'

export function getAiAppMenu(data) {
  return request({
    url: '/inside/mobile/ai/menu/qcaMenuList',
    data
  })
}

// 获取是否还有额度
export function getIntentionQuota(data) {
  return request({
    url: '/inside/intention/quota',
    data
  })
}

export function getSignature(data) {
  return request({
    url: '/aliyun/oss/getSignature',
    data
  })
}
